import { render, staticRenderFns } from "./UnServer.vue?vue&type=template&id=2a91a0d7&scoped=true&"
import script from "./UnServer.vue?vue&type=script&lang=js&"
export * from "./UnServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91a0d7",
  null
  
)

export default component.exports